module.exports = __webpack_public_path__ + "static/media/bookbanner.6324d611.svg";